import globalMoment from "../GlobalMoment";

export default {
    mixins: [globalMoment],
    data() {
        return {
            recurrenceEndAlert: null,
            bookingInPastAlert: null,
            futureConflictAlert: null,
            teacherConflictAlert: null,
            axiosAlert: null,
            guestSessionExpired: null,
            noRescheduleAlert: null,
            allRescheduleStudentsAlert: null,
            noPurchaseOptionAlert: null,
            futureBookingConflict: null,
            assessmentConflictAlert: null,
            assessmentConflict: null,
            noConflict: false,
            teacherUnavailableAlert: false,
            missingPurchaseOption: false,
            requiresAssignmentAlert: false,
            bookingOutsideLocationAlert: false,
            studentRescheduleGroupEvent: false,
            teacherAvailableNotAssignedAlert: false,
            bookingPastMembershipEndAlert: false,
            unpaidAlert: null,
        };
    },
    methods: {
        // Build alert components
        showAxiosAlert(error) {
            this.axiosAlert = {
                title: "Something went wrong",
                subtitle:
                    error ??
                    "Please try again or contact support at feedback@musicologie.com",
                button1: "Okay",
                option1: () => {
                    this.form.startDate = null;
                    this.backStep ? this.backStep() : null;
                    this.closeModal((this.axiosAlert = null));
                },
                permanent: true,
                priority: 1,
            };
            // automate to api endpoint to slack notification instead of showing email address?
        },
        showGuestSessionExpired(error) {
            this.axiosAlert = {
                title: "Sorry!",
                subtitle:
                    error ??
                    "Please try again or contact support at feedback@musicologie.com",
                button1: "Okay",
                option1: () => {
                    this.$inertia.visit("/get-started/lessons");
                },
                permanent: true,
                priority: 1,
            };
            // automate to api endpoint to slack notification instead of showing email address?
        },
        showFutureConflictAlert(error) {
            if (
                (this.form.type.assessment ||
                    this.form.type.originalType == "Assessment") &&
                !error[0]?.registration_event &&
                error[0]?.recurrence_id
            ) {
                return;
            }

            const allowBooking =
                this.$page.props.staffView &&
                this.form.repeating &&
                !error[0]?.recurrence_id;

            this.futureBookingConflict = error;
            this.futureConflictAlert = {
                title: "Uh oh",
                subtitle: allowBooking
                    ? "Schedule all weekly lessons except for the following conflicts? Unscheduled lessons will be able to be rescheduled."
                    : "A booking conflict is preventing this lesson from being scheduled.",
                button1: allowBooking ? "Okay" : false,
                button2: "Go back",
                option1: () => this.handleFutureConflicts(error),
                option2: () => {
                    this.closeModal(() => (this.futureConflictAlert = null));
                    this.backStep ? this.backStep() : null;
                    this.futureBookingConflict = null;
                },
                permanent: true,
                priority: 1,
            };
        },
        showAssessmentConflictAlert(error) {
            if (
                !this.form.type.assessment &&
                this.form.type.originalType !== "Assessment"
            ) {
                return;
            }
            if (!error[0]?.recurrence_id) return;
            this.assessmentConflict = error;
            this.assessmentConflictAlert = {
                title: "Are you sure?",
                subtitle:
                    "This time is reserved for a recurring lesson or event series and is not recommended for an assessment.",
                button1: "Book anyways",
                button2: "Nevermind",
                option1: () => this.handleAssessmentConflicts(),
                option2: () => {
                    this.closeModal(
                        () => (this.assessmentConflictAlert = null)
                    );
                    this.assessmentConflict = null;
                },
                permanent: true,
                priority: 1,
            };
        },
        showTeacherAvailableNotAssignedAlert() {
            if (
                !this.form.teacher ||
                this.assignment ||
                !this.$_data_lessonStart ||
                !this.availability
            ) {
                return;
            }
            this.teacherAvailableNotAssignedAlert = {
                title: "Uh oh",
                subtitle: `${
                    this.$page.props.auth.user.id == this.form.teacher.id
                        ? "You are"
                        : `${this.form.teacher.name} is`
                } available on ${this.form.startDate} at ${
                    this.form.startTime
                }, but not assigned to this room. Continue?`,
                button1: "Okay",
                button2: "Go back",
                option1: () =>
                    this.closeModal(
                        () => (this.teacherAvailableNotAssignedAlert = null)
                    ),
                option2: () => {
                    this.closeModal(
                        () => (this.teacherAvailableNotAssignedAlert = null)
                    );
                    this.backStep();
                },
                permanent: true,
                priority: 1,
            };
        },
        showTeacherUnavailableAlert() {
            if (
                !this.form.teacher ||
                this.availability ||
                !this.$_data_lessonStart ||
                this.form.teacher?.isLocation
            ) {
                return;
            }
            this.teacherUnavailableAlert = {
                title: "Uh oh",
                subtitle: `${
                    this.$page.props.auth.user.id == this.form.teacher.id
                        ? "You are"
                        : `${this.form.teacher.name} is`
                } not available on ${this.form.startDate} at ${
                    this.form.startTime
                } in ${this.form.room.title}. Continue?`,
                button1: "Okay",
                button2: "Go back",
                option1: () =>
                    this.closeModal(
                        () => (this.teacherUnavailableAlert = null)
                    ),
                option2: () => {
                    this.closeModal(
                        () => (this.teacherUnavailableAlert = null)
                    );
                    this.backStep();
                },
                permanent: true,
                priority: 1,
            };
        },
        showTeacherConflictAlert(error) {
            this.teacherConflictAlert = {
                title: "Uh oh",
                subtitle: error,
                button1: "Okay",
                option1: () => this.handleTeacherConflictAlert(),
                permanent: true,
                priority: 1,
            };
        },
        showNoRescheduleAlert(student) {
            if (!this.form.student && !student) return;
            if (this.noPurchaseOptionAlert) return;
            if (!this.form.type?.reschedule) return;

            let getStudent = this.form.student ?? student;
            let subject =
                getStudent.id == this.$page.props.auth.user.id
                    ? "You do"
                    : `${getStudent.first_name} does`;

            this.noRescheduleAlert = {
                title: "Uh oh",
                subtitle: `${subject} not have enough eligible missed lessons for this selection`,
                button1: "Okay",
                button2:
                    this.can("Override reschedules") &&
                    this.$page.props.staffView
                        ? "Override"
                        : null,
                option1: () => {
                    /**
                     * @since v1.87294
                     * Check if a purchase option was auto-selected before clearing the student
                     * Different behavior is expected for the BookingPurchaseOption component
                     */
                    if (!this.form.purchaseOption) this.form.student = null;
                    this.backStep();
                    this.closeModal(() => {
                        this.noRescheduleAlert = null;
                    });
                },
                option2: () => {
                    this.showAllRescheduleStudentsAlert();
                    this.closeModal(() => (this.noRescheduleAlert = null));
                },
                permanent: true,
                priority: 2,
            };

            return true;
        },
        showAllRescheduleStudentsAlert() {
            this.allRescheduleStudentsAlert = {
                title: "Are you sure?",
                subtitle:
                    "This will give the selected student a rescheduled lesson even if they don't have an eligible cancellation. This is the equivalent of a free lesson.",
                button1: "Nevermind",
                button2: "Continue",
                option1: () => {
                    this.form.student = null;
                    this.backStep();
                    this.closeModal(
                        () => (this.allRescheduleStudentsAlert = null)
                    );
                },
                option2: () => {
                    //this.form.duration = 30;
                    this.form.purchaseOption.name = "Courtesy Reschedule";
                    this.form.courtesyReschedule = true;
                    (this.form.billingUser.name =
                        "Musicologie " +
                        this.$page.props.auth.user.selected_location.name),
                        (this.form.credit = null);
                    this.closeModal(
                        () => (this.allRescheduleStudentsAlert = null)
                    );
                },
                permanent: true,
                priority: 2,
            };
        },
        showNoPurchaseOptionAlert() {
            if (!this.form.student) return;
            if (this.bookingPastMembershipEndAlert) return;

            this.noPurchaseOptionAlert = {
                title: "Uh oh",
                subtitle: `${this.form.student.name} does not have an available purchase option for this selection.`,
                button1: "Okay",
                option1: () => {
                    this.bookingSource.isSelfServe
                        ? null
                        : (this.form.student = null);
                    this.backStep();
                    this.closeModal(() => (this.noPurchaseOptionAlert = null));
                },
                button2:
                    this.$page.props.staffView &&
                    (this.form.billingUser || this.form.student?.email)
                        ? "Visit Store"
                        : null,
                option2: () => {
                    this.$inertia.visit(
                        route("store", this.form.billingUser?.id)
                    );
                },
                permanent: true,
                priority: 2,
            };
        },
        showRecurrenceEndAlert(error) {
            if (!this.assignment?.recurrence?.ends_at) return;
            if (!this.form.repeating) return;
            this.recurrenceEndAlert = {
                title: "Hey!",
                subtitle: `This assignment ends on ${this.globalMomentDate(
                    this.assignment.recurrence.ends_at
                )}. Would you like to schedule with ${
                    this.form.teacher.first_name
                } until then?`,
                button1: "Ok",
                option1: () =>
                    this.closeModal(() => (this.recurrenceEndAlert = null)),
                permanent: true,
                priority: 1,
            };
        },
        showBookingInPastAlert(error) {
            //if (this.form.assessmentType?.name) return;
            if (this.form.type?.hold) return;
            if (this.form.type?.event) return;
            if (this.$_data_lessonStart.isAfter(moment())) return;
            this.bookingInPastAlert = {
                title: "Heads up!",
                subtitle:
                    "This lesson is being scheduled in the past. Neither the student or the teacher will be notified.",
                button1: "Okay",
                option1: () =>
                    this.closeModal(() => (this.bookingInPastAlert = null)),
                permanent: true,
                priority: 2,
            };
        },
        showBookingPastMembershipEndAlert(error) {
            let canProceed = this.can("Reschedule past membership end");

            this.bookingPastMembershipEndAlert = {
                title: canProceed ? "Heads up!" : "Sorry!",
                subtitle:
                    "Lessons are unable to be rescheduled past the membership end date.",
                button1: canProceed ? "Book anyways" : "Okay",
                button2: canProceed ? "Nevermind" : null,
                option1: () => {
                    canProceed ? null : this.backStep();
                    this.closeModal(
                        () => (this.bookingPastMembershipEndAlert = null)
                    );
                },
                option2: () => {
                    this.backStep();
                    this.closeModal(
                        () => (this.bookingPastMembershipEndAlert = null)
                    );
                },
                permanent: true,
                priority: 1,
            };
        },
        showRequiresAssignmentAlert(error) {
            if (!this.bookingSource.isCalendar) return;
            if (this.form.type?.hold) return;
            if (this.form.repeating == false) return;
            if (!this.$_data_lessonStart) return;
            if (this.form.templateEvent?.registration_event) return;

            // validate assignment
            if (this.assignment) {
                let assignmentStart = moment(this.assignment.starts_at);
                let assignmentEnd = moment(this.assignment.ends_at);
                let lessonRecurrenceError =
                    this.form.repeating && !this.assignment.recurrence_id;
                if (
                    this.$_data_lessonStart.isBetween(
                        assignmentStart,
                        assignmentEnd,
                        null,
                        "[]"
                    ) &&
                    this.$_data_lessonEnd.isBetween(
                        assignmentStart,
                        assignmentEnd,
                        null,
                        "[]"
                    ) &&
                    !lessonRecurrenceError
                )
                    return;
            }

            this.requiresAssignmentAlert = {
                title: "Uh oh",
                subtitle:
                    "This lesson or event type repeats weekly and requires a recurring assignment.",
                button1: "Okay",
                option1: () => {
                    this.backStep();
                    this.closeModal(
                        () => (this.requiresAssignmentAlert = null)
                    );
                },
                permanent: true,
                priority: 1,
            };
        },
        showBookingOutsideLocationAlert(error) {
            if (
                this.$page.props.auth.user.locations
                    .map((e) => e.id)
                    .includes(this.form.location.id)
            ) {
                return;
            }
            this.bookingOutsideLocationAlert = {
                title: "Are you sure?",
                subtitle: "This class is outside of your usual location(s)",
                button1: "Yep!",
                button2: "Nevermind",
                option1: () => {
                    this.closeModal(
                        () => (this.bookingOutsideLocationAlert = null)
                    );
                },
                option2: () => {
                    this.backStep();
                    this.closeModal(
                        () => (this.bookingOutsideLocationAlert = null)
                    );
                },
                permanent: true,
                priority: 1,
            };
        },
        showUnpaidAlert(purchaseOption) {
            if (!this.form.student) return;
            if (!this.$page.props.staffView) return;
            if (
                purchaseOption?.subPaid ||
                !purchaseOption ||
                purchaseOption.name == "Due at Checkout" ||
                !purchaseOption.cycle
            )
                return;

            this.unpaidAlert = {
                title: "Uh oh",
                subtitle:
                    "This student has an unpaid membership and is unable to reschedule lessons",
                button1: "Okay",
                option1: () => {
                    this.backStep();
                    this.unpaidAlert = null;
                },
                permanent: true,
                priority: 1,
            };
        },
        /*$_alerts_showMissingPurchaseOptionAlert(error) {
            if (this.purchaseOption) return;
            this.missingPurchaseOption = {
                title: "Uh oh!",
                subtitle:
                    "This client doesn't have a valid purchase option for this selection. Would you like to sell them one now?",
                button1: "Visit Store",
                button2: "Go Back",
                option1: () =>
                    this.$inertia.visit("/store", {
                        billingUser: this.form.billingUser?.id,
                    }),
                option2: () => {
                    this.backStep();
                    this.closeModal(() => (this.missingPurchaseOption = null));
                },
                permanent: true,
                priority: 1,
            };
        },*/
        /**
         *
         *
         */
        handleTeacherConflictAlert() {
            if (this.$_data_authIsOnlyTeacher || !this.can("Work")) {
                return this.$emit("reset");
            }
            this.closeModal(() => (this.teacherConflictAlert = null));
            this.teacherUnavailableAlert = null;
            this.jumpToStep(this.stepSequence.find((e) => e.name == "teacher"));
        },
        handleFutureConflicts(error) {
            if (!this.form.type?.weeklyLesson) {
                // will not allow booking to proceed
                this.futureBookingConflict = null;
                this.closeModal(() => (this.futureConflictAlert = null));
                return;
            }
            // only warning, allows booking to proceed
            this.noConflict = true;
            this.conflicts = this.futureBookingConflict.map((e) => e.id);
            this.submit();
            this.futureBookingConflict = null;
            this.closeModal(() => (this.futureConflictAlert = null));
        },
        handleAssessmentConflicts() {
            // only warning, allows booking to proceed
            this.noConflict = true;
            if (!this.form.type?.assessment) return;
            this.conflicts = [];
            this.submit();
            this.assessmentConflict = null;
            this.closeModal(() => (this.assessmentConflictAlert = null));
        },
    },
    computed: {
        alerts() {
            let alerts = {
                axiosAlert: this.axiosAlert,
                guestSessionExpired: this.guestSessionExpired,
                futureConflictAlert: this.futureConflictAlert,
                assessmentConflictAlert: this.assessmentConflictAlert,
                teacherConflictAlert: this.teacherConflictAlert,
                noRescheduleAlert: this.noRescheduleAlert,
                noPurchaseOptionAlert: this.noPurchaseOptionAlert,
                bookingInPastAlert: this.bookingInPastAlert,
                bookingPastMembershipEndAlert:
                    this.bookingPastMembershipEndAlert,
                recurrenceEndAlert: this.recurrenceEndAlert,
                teacherUnavailableAlert: this.teacherUnavailableAlert,
                missingPurchaseOption: this.missingPurchaseOption,
                requiresAssignmentAlert: this.requiresAssignmentAlert,
                bookingOutsideLocationAlert: this.bookingOutsideLocationAlert,
                allRescheduleStudentsAlert: this.allRescheduleStudentsAlert,
                teacherAvailableNotAssignedAlert:
                    this.teacherAvailableNotAssignedAlert,
                unpaidAlert: this.unpaidAlert,
            };
            return Object.fromEntries(
                Object.entries(alerts)
                    .filter((e) => !!e[1])
                    .sort((a, b) => a.priority - b.priority)
            );
        },
    },
};
